export default "__VITE_ASSET__D8dscuU9__"